<script>
  import { date_uploaded } from "@/utils";
  import * as PropTypes from "prop-types";
  const { checkPropTypes, string, object } = PropTypes;
  import * as utils from "@/utils/helpers/utils";
  export let item;
  export let videoId;
  export let isSocialProofingVariant;
  export let isPlayThumbnailVariant;
  import { onMount } from "svelte";

  $: meta_title = isSocialProofingVariant
    ? utils.getOgTitle(item)
    : item.n && `${item.n} on Moj`;
  $: meta_desc = isSocialProofingVariant
    ? utils.getOgDescription(item)
    : utils.getCaption(item);
  $: meta_image = isPlayThumbnailVariant
    ? utils.getPlayThumbnail(item)
    : item.b;

  import config from "@/config";
  const { siteDomain } = config;
  const breadcrumbJson = [
    {
      "@type": "ListItem",
      position: 1,
      item: {
        "@id": `${siteDomain}/`,
        name: "Home",
      },
    },
    {
      "@type": "ListItem",
      position: 2,
      item: {
        "@id": `${siteDomain}/@${item?.ath?.h}`,
        name: "Profile",
      },
    },
    {
      "@type": "ListItem",
      position: 3,
      item: {
        "@id": `${siteDomain}/@${item?.ath?.h}/video/${videoId}`,
        name: "Video",
      },
    },
  ];
  $: metaObject = {
    ...utils.DEFAULT_META_DATA,
    ...(item.n ? { title: `${item.n} on Moj` } : {}),
    ...(item.c ? { description: item.c } : {}),
    og_tags: [
      { p: "og:title", c: meta_title },
      { p: "og:description", c: meta_desc },
      { p: "og:image", c: meta_image },
      {
        p: "og:video",
        c: item.attributedVideoUrl || item.v || item.compressedVideoUrl,
      },
      {
        p: "og:video:url",
        c: item.attributedVideoUrl || item.v || item.compressedVideoUrl,
      },
      {
        p: "og:video:secure_url",
        c: item.attributedVideoUrl || item.v || item.compressedVideoUrl,
      },
      { p: "og:video:width", c: item.w || 200 },
      { p: "og:video:height", c: item.h || 200 },
      { p: "og:video:type", c: "video/mp4" },
      { p: "al:ios:url", c: `mojapp://video/${videoId}` },
    ],
  };
  export const contentJson = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: item.n || (item.c || "").trim(), // put [caption] in name key or [Name] ([handle]) if caption is undefined
    description: `${item.c} - Uploaded by ${item.n} (${item.ath?.h}) on Moj with music ${item.audioMeta?.audioName}`,
    // format: [caption] + Uploaded by [Name] ([handle]) on Moj with music [music name]
    thumbnailUrl: [
      item.b,
      item.thumbWithOverlay || "",
      ...(item.secondaryThumbs || []),
    ],
    uploadDate: date_uploaded(item.o),
    inLanguage: `${item.m ? item.m.slice(0, 2).toLowerCase() : "hi"}-IN`,
    isFamilyFriendly: item.adult == "0",
    duration: `PT${
      Math.floor(item.d) || Math.floor(2 + Math.random() * 3) * 60
    }S`,
    contentUrl: item.attributedVideoUrl || item.v || item.compressedVideoUrl, // cdn link (compressed and watermarked one)
    // "embedUrl": "https://www.example.com/embed/123", //we will need to create an embed url like we did for sc
    width: item.w,
    height: item.h,
    creator: {
      "@type": "Person",
      name: item.ath?.n, // creator name
      url: `https://mojapp.in/@${item.ath?.h}`, // moj profile deeplink
      alternateName: item.ath?.h, // handle
      interactionStatistic: [
        {
          "@type": "InteractionCounter",
          interactionType: {
            "@type": "http://schema.org/LikeAction",
          }, // total likes of a profile
          userInteractionCount: item.ath?.likeCount,
        },
        {
          "@type": "InteractionCounter",
          interactionType: {
            "@type": "http://schema.org/FollowAction",
          }, // number of followers
          userInteractionCount: item.ath?.f,
        },
      ],
    },
    interactionStatistic: [
      {
        "@type": "InteractionCounter",
        interactionType: { "@type": "http://schema.org/WatchAction" }, // number of video plays of this particular video
        userInteractionCount: item.l || 0,
      },
      {
        "@type": "InteractionCounter",
        interactionType: { "@type": "http://schema.org/LikeAction" }, // total likes of video
        userInteractionCount: item.lc,
      },
      {
        "@type": "InteractionCounter",
        interactionType: { "@type": "http://schema.org/ShareAction" }, // no of shares
        userInteractionCount: item.us,
      },
    ],
    commentCount: item.c2,
    // comment: [
    //  {
    //      "@type": "Comment",
    //      text: "Awesome video!", //comment text
    //      creator: {
    //          "@type": "Person",
    //          name: "Jane Doe", //name of the commentor
    //          url: "https://www.example.com/user/jdoe"
    //      }, //profile deeplink of commentor
    //      interactionStatistic: {
    //          "@type": "InteractionCounter",
    //          interactionType: {
    //              "@type": "http://schema.org/LikeAction"
    //          }, //number of likes of the comment
    //          userInteractionCount: 10
    //      }
    //  },
    //  {
    //      "@type": "Comment",
    //      text: "Love this!",
    //      creator: {
    //          "@type": "Person",
    //          name: "Adam",
    //          url: "https://www.example.com/user/adamiscool"
    //      },
    //      interactionStatistic: {
    //          "@type": "InteractionCounter",
    //          interactionType: {
    //              "@type": "http://schema.org/LikeAction"
    //          },
    //          userInteractionCount: 5
    //      }
    //  },
    //  {
    //      "@type": "Comment",
    //      text: "So cool!",
    //      creator: {
    //          "@type": "Person",
    //          name: "Eve",
    //          url: "https://www.example.com/user/eve99"
    //      },
    //      interactionStatistic: {
    //          "@type": "InteractionCounter",
    //          interactionType: {
    //              "@type": "http://schema.org/LikeAction"
    //          },
    //          userInteractionCount: 2
    //      }
    //  }
    // ]
  };

  const propTypes = {
    item: object,
    videoId: string,
    metaObject: object,
    contentJson: object,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "VideoItemHead");
  });
</script>

<svelte:head>
  <title>{metaObject.title}</title>
  <meta name="description" content={`${metaObject.description}`} />
  {#each metaObject.og_tags as tag}
    <meta property={`${tag.p}`} content={`${tag.c}`} />
  {/each}
</svelte:head>
<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html `<script type="application/ld+json">${`${JSON.stringify(
  contentJson
)}<`}/script>`}
<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html `<script type="application/ld+json">${`${JSON.stringify({
  "@context": "http://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: breadcrumbJson,
})}<`}/script>`}
